import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_uom_convertService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { owner: string, project: string, material: string, from_uom: string, from_quantity: number, to_uom?: string, to_default?: boolean }): Promise<{ to_quantity?: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.owner)) {
      $missingRequiredInParams.push('\'owner\'');
    }
    if (isNil($inParams.project)) {
      $missingRequiredInParams.push('\'project\'');
    }
    if (isNil($inParams.material)) {
      $missingRequiredInParams.push('\'material\'');
    }
    if (isNil($inParams.from_uom)) {
      $missingRequiredInParams.push('\'from_uom\'');
    }
    if (isNil($inParams.from_quantity)) {
      $missingRequiredInParams.push('\'from_quantity\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

